import styles from './index.module.scss';
import SectionPro from '../components/SectionPro';
import EFPicture from '@elem/compCommon/EFPicture';
import FSwiper from '../components/FSwiper';

const Safe: React.FC = () => {
    const items = [
        {
            title: 'リン酸鉄リチウムイオンバッテリー',
            desc: '高品質のリン酸鉄リチウムイオン（LFP）バッテリー搭載。火災リスクがきわめて低く高耐久のため、10年間の長い寿命で安心して使用できます。',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744980550255/%E3%83%AA%E3%83%B3%E9%85%B8%E9%89%84%E3%83%AA%E3%83%81%E3%82%A6%E3%83%A0%E3%82%A4%E3%82%AA%E3%83%B3%E3%83%8F%E3%82%99%E3%83%83%E3%83%86%E3%83%AA%E3%83%BC%20(1).jpg',
            h5: '',
        },
        {
            title: '高度なバッテリーマネージメントシステム',
            desc: '独自アルゴリズムを搭載した最先端のBMSが、バッテリーを制御する「頭脳」として過電流や温度・電圧変動、発火や爆発を防止。安全性はもちろん、バッテリー性能を最大限に引き出します。',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744980695842/%E9%AB%98%E5%BA%A6.jpg',
            h5: '',
        },
        {
            title: '高耐久設計',
            desc: 'DELTA 2 Maxは、本体や各種ポートを含め、摩耗や損傷に強く設計されています。屋外でも安心して使用できるだけでなく、持ち運びにも便利なデザインが採用されています。',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744980558347/%E9%AB%98%E8%80%90%E4%B9%85%E8%A8%AD%E8%A8%88%20(1).jpg',
            h5: '',
        },
    ];
    return (
        <div className={`${styles.Safe} GtmModuleData-section`} id="Safe" data-section-id={styles.Safe} data-section-title="安全・安心を保証する3つのポイント">
            <SectionPro
                title={
                    <div>
                        安全・安心を保証する
                        <br />
                        3つのポイント
                    </div>
                }
                desc="高品質バッテリー、BMS、高耐久"
            >
                <div className="list">
                    <FSwiper>
                        {items.map((item) => {
                            return (
                                <div className="item" key={item.title}>
                                    <EFPicture src={item.pc} />
                                    <div className="text-box">
                                        <div className="title">{item.title}</div>
                                        <div className="desc">{item.desc}</div>
                                    </div>
                                </div>
                            );
                        })}
                    </FSwiper>
                </div>
            </SectionPro>
        </div>
    );
};

export default Safe;
